// Export the main store and all hooks
export * from './global-store';

// Export the store provider
export * from './store-provider';
